import { SECONDS_PER_HOUR, SECONDS_PER_MINUTE } from '@meteoradar/shared/time/units';

export const DISPLAY_TIME_ZONE = 'Europe/Madrid';

const dateTimeFormat = new Intl.DateTimeFormat('es-ES', {
  timeZone: DISPLAY_TIME_ZONE,
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const timeFormat = new Intl.DateTimeFormat('es-ES', {
  timeZone: DISPLAY_TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export const formatFrameDateTime = (iso: string): string => dateTimeFormat.format(new Date(iso));

export const formatFrameTime = (iso: string): string => timeFormat.format(new Date(iso));

export const formatAge = (seconds: number | null): string => {
  if (seconds === null) {
    return 'sin datos';
  }
  if (seconds < SECONDS_PER_MINUTE) {
    return 'ahora mismo';
  }
  if (seconds < SECONDS_PER_HOUR) {
    return `hace ${Math.floor(seconds / SECONDS_PER_MINUTE)} min`;
  }
  const hours = Math.floor(seconds / SECONDS_PER_HOUR);
  const minutes = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
  return minutes === 0 ? `hace ${hours} h` : `hace ${hours} h ${minutes} min`;
};

export const formatSpeed = (value: number): string => `${value}×`;

export const formatWindow = (hours: number): string => `${hours} h`;
